import * as R from 'ramda';

export interface AdvancedSearchRequiredFields {
  [key: string]: any;
}

type AddRequiredField = (key: string, value: any, requiredFields: AdvancedSearchRequiredFields) => AdvancedSearchRequiredFields;
export const addRequiredField: AddRequiredField = (key, value, requiredFields) => R.mergeDeepRight(requiredFields, {
  [key]: value
});

type GetRequiredFieldsKeys = (requiredFields: AdvancedSearchRequiredFields) => string[];
export const getRequiredFieldsKeys: GetRequiredFieldsKeys = R.keys;

type IsRequiredField = (fieldName: string, requiredFields: AdvancedSearchRequiredFields) => boolean;
export const isRequiredField: IsRequiredField = (fieldName: string, requiredFields: AdvancedSearchRequiredFields) =>
  R.compose(R.includes(fieldName), getRequiredFieldsKeys)(requiredFields);
